import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { QuestionTypeMaster } from "../../entities/question-type-master";

@Injectable()
export class QuestionTypeMasterRepo extends Repository<QuestionTypeMaster>{
    constructor(private dataSource: DataSource) {
        super(QuestionTypeMaster, dataSource.createEntityManager());
    }
}
